import { Observable, Subscription } from 'rxjs'
import { finalize, share, tap } from 'rxjs/operators'

export function subscriptionActive(subscription: Subscription) {
  return !!subscription && !subscription.closed
}

export class ObservableCache<T> {
  /*
    Cache observables so that they can be shared across multiple subscribers who are trying to
    access the same data.
    */
  private observableCache: Map<string, Observable<T>> = new Map<string, Observable<T>>()

  cache(key: string, observable: Observable<T>) {
    /*
        If there's an active observable multicasting, return that.  
        If not, cache the one that is passed in and return it.
        */
    if (this.observableCache.has(key)) {
      return this.observableCache.get(key)
    }
    observable = observable.pipe(
      finalize(() => {
        this.observableCache.delete(key)
      }),
      share()
    )
    this.observableCache.set(key, observable)
    return observable
  }
}
